import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faLayerGroup, faUsers } from "@fortawesome/free-solid-svg-icons";
import { BasicContext } from "../../../App";
import { postMethod } from "../../../requests";
import Search from "../../../components/inputs/Search";
import LoadedRecords from "../../../components/LoadedRecords";
import moment from "moment";
import { faCalendar, faEye } from "@fortawesome/free-regular-svg-icons";
import Students2ClassModal from "../../../components/modals/Students2ClassModal";

const HistoryClasses = () => {
    const { t } = useTranslation();
    const { checkServerData, NOR } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [originalList, setOriginalList] = useState(null);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [displayNOR, setDisplayNOR] = useState(NOR);
    const [showStudentsListModal, setShowStudentsListModal] = useState(false);

    const getClassesList = async () => {
        const res = await postMethod("/history-classes-list");
        if (checkServerData(res)) {
            setList(res.data.list);
            setOriginalList(res.data.list);
        }
    };

    const handleSearch = (v) => {
        const searchedPhrase = v.toLowerCase();
        setSearch(searchedPhrase);
        if (searchedPhrase !== "") {
            let filterThisList = originalList;
            filterThisList = filterThisList.filter(
                (el) =>
                    el.instructor_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.class_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.instructor_surname.toString().toLowerCase().includes(searchedPhrase) ||
                    moment(el.class_start_time).format("DD.MM.YYYY").toString().toLowerCase().includes(searchedPhrase) ||
                    moment(el.class_start_time).format("HH:mm").toString().toLowerCase().includes(searchedPhrase) ||
                    moment(el.class_end_time).format("HH:mm").toString().toLowerCase().includes(searchedPhrase) ||
                    el.class_level_name.toString().toLowerCase().includes(searchedPhrase)
            );
            setList(filterThisList);
        } else {
            setList(originalList);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        if (!list) getClassesList();

        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">{t("loadingData")}</p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 my-4 px-lg-2 ">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("classes.historyClassesList")}</h1>
                                <Button
                                    className="float-end d-inline-block me-2"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setLoading(true);
                                        getClassesList();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowsRotate} />
                                </Button>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-lg-4 my-3 px-lg-2 ">
                                <Search value={search} onChange={(e) => handleSearch(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            {list.length > 0 ? (
                                <Fragment>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="px-0 px-lg-2 ">
                                        <Table className="white-table">
                                            <tbody>
                                                {list
                                                    .map((c, i) => (
                                                        <Fragment key={i}>
                                                            <tr className={`class-lvl-bg-${c.class_level_colour ? c.class_level_colour : "white"}`}>
                                                                <td rowSpan={2} className="pe-0">
                                                                    <FontAwesomeIcon icon={faCalendar} />
                                                                </td>
                                                                <td className="border-bottom-0 pb-0 bold">{moment(c.class_start_time).format("DD.MM.YYYY")}</td>
                                                                <td className="border-bottom-0 pb-0 bold">{c.class_name}</td>
                                                                <td className="border-bottom-0 pb-0 ">
                                                                    <FontAwesomeIcon icon={faLayerGroup} className="me-1" />
                                                                    {c.class_level_name.length > 8 ? c.class_level_name.substr(0, 8) + "." : c.class_level_name}
                                                                </td>
                                                                <td rowSpan={3}>
                                                                    <Button variant="outline-secondary" size="sm" onClick={() => setShowStudentsListModal(c)}>
                                                                        <FontAwesomeIcon icon={faEye} />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                            <tr className={`class-lvl-bg-${c.class_level_colour ? c.class_level_colour : "white"}`}>
                                                                <td className="bold border-bottom-0 pb-0">
                                                                    {moment(c.class_start_time).format("HH:mm")}–{moment(c.class_end_time).format("HH:mm")}
                                                                </td>
                                                                <td className="border-bottom-0 pb-0">
                                                                    {c.instructor_name} {c.instructor_surname}
                                                                </td>
                                                                <td className="pe-0 border-bottom-0 pb-0">
                                                                    <FontAwesomeIcon icon={faUsers} className="me-1" />
                                                                    {t("classes.presentStudents")}: {c.cnt_present}
                                                                </td>
                                                            </tr>
                                                            <tr className={`class-lvl-bg-${c.class_level_colour ? c.class_level_colour : "white"}`}>
                                                                <td></td>
                                                                <td className="" colSpan={3}>
                                                                    {t("status")}: <span className="bold">{t(`classes.classStatuses.${c.class_status_code}`)}</span>
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    ))
                                                    .slice(0, displayNOR)}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="text-center">
                                        {displayNOR >= list.length ? (
                                            <p className="opacity-4  mb-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                {t("loadMore")}
                                            </Button>
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}

            {showStudentsListModal && <Students2ClassModal c={showStudentsListModal} onClose={() => setShowStudentsListModal(false)} />}
        </Fragment>
    );
};

export default HistoryClasses;
